// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import MobileNavigationController from "./mobile_navigation_controller"
application.register("mobile-navigation", MobileNavigationController)
